/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

'use strict';

exports = module.exports = require('./lib/memoizer')['default'];
exports['default'] = exports;




//////////////////
// WEBPACK FOOTER
// ./node_modules/intl-format-cache/index.js
// module id = 1091
// module chunks = 76